// Starter service templates keyed by category id.
//
// These are the "menu defaults" we surface during provider onboarding so a
// new stylist doesn't have to type out their entire service list from
// scratch. When the provider ticks a category in CategoriesStep, all
// templates for that category appear pre-checked in ServicesStep. They
// can untick anything they don't offer, edit price/duration inline, then
// continue. Each entry has a stable `template_id` so the picker can track
// state across re-renders.
//
// Pricing is a sensible UK median for Feb 2026, easily editable by the
// provider before submission.
export const SERVICE_TEMPLATES = {
  locs_braids_protective: [
    { template_id: 'locs.knotless_braids', name: 'Knotless Braids', duration: 240, price: 120 },
    { template_id: 'locs.loc_retwist', name: 'Loc Retwist', duration: 120, price: 70 },
    { template_id: 'locs.weave_sew_in', name: 'Weave Sew-In', duration: 150, price: 100 },
  ],
  hair_styling_care: [
    { template_id: 'hair.silk_press', name: 'Silk Press', duration: 90, price: 65 },
    { template_id: 'hair.precision_cut_blowdry', name: 'Precision Cut & Blow-Dry', duration: 60, price: 50 },
  ],
  barbering_grooming: [
    { template_id: 'barber.skin_fade', name: 'Skin Fade', duration: 45, price: 30 },
    { template_id: 'barber.beard_lineup', name: 'Beard Line-up & Shape', duration: 30, price: 20 },
  ],
  aesthetics_skin: [
    { template_id: 'aesthetics.hyperpig_facial', name: 'Melanin-Safe Hyperpigmentation Facial', duration: 60, price: 75 },
    { template_id: 'aesthetics.chemical_peel', name: 'Chemical Peel', duration: 45, price: 90 },
  ],
  nails_nail_art: [
    { template_id: 'nails.biab_manicure', name: 'BIAB Manicure', duration: 60, price: 35 },
    { template_id: 'nails.full_set_acrylics', name: 'Full Set Acrylics', duration: 90, price: 45 },
  ],
  lashes_brows: [
    { template_id: 'lashes.classic_set', name: 'Full Set Classic Lashes', duration: 90, price: 60 },
    { template_id: 'brows.lamination_tint', name: 'Brow Lamination & Tint', duration: 45, price: 40 },
  ],
  makeup_glam: [
    { template_id: 'makeup.evening_glam', name: 'Full Face Evening Glam', duration: 60, price: 60 },
  ],
};

// Flat list of all templates with their category attached. Useful for any
// caller that just wants every default (e.g. an admin "reset to defaults"
// button later).
export function getAllTemplates() {
  const out = [];
  for (const [category, items] of Object.entries(SERVICE_TEMPLATES)) {
    for (const t of items) out.push({ ...t, category });
  }
  return out;
}

// Templates for a set of category ids, in the order the categories were
// supplied. Returns each template stamped with its category so the
// ServicesStep can group them under a heading.
export function getTemplatesForCategories(categoryIds) {
  const out = [];
  for (const catId of categoryIds || []) {
    const tpl = SERVICE_TEMPLATES[catId];
    if (!tpl) continue;
    for (const t of tpl) {
      out.push({ ...t, category: catId });
    }
  }
  return out;
}
